
import { Component, Mixins } from "vue-property-decorator";
import { ITextDrawable, instanceOfITextDrawable, IDrawableItem } from "../../../../../domain/document/items";
import { TextStyle, TextAlignKinds } from "../../../../../domain/drawing";
import { ITextStyleReadable, instanceOfITextStyleReadable } from "../..";
import { IObjectStyleReadable } from "../../IObjectStyleReadable";
import { BrowserUtility, BrowserKinds, DecimalUtility } from "../../../../../utilities";

@Component({
})
export default class StyledTextDrawableMixin extends Mixins() {
  editingSource: IDrawableItem;
  editStyleReader: IObjectStyleReadable;  // 実装するObject側に用意.
  shouldInputFreeAll: boolean;            // フリー入力対象の場合は定義されている.
  isFocused: boolean;                     // DrawableObjectMixinで@Prop定義されているため更新しないこと

  get textStyleReader(): ITextStyleReadable {
    if (!this.editStyleReader) {
      return null;
    }
    if (instanceOfITextStyleReadable(this.editStyleReader)) {
      return this.editStyleReader as ITextStyleReadable;
    }
    throw new Error("editStyleReaderがITextStyleReadableを実装していません.実装を確認してください.");
  }

  get sourceAsTextDrawableObject(): ITextDrawable {
    if (instanceOfITextDrawable(this.editingSource)) {
      return this.editingSource as ITextDrawable;
    }
    throw new Error("editingSourceがITextDrawableを実装していません.実装を確認してください.");
  }

  get textStyle(): TextStyle {
    return this.textStyleReader
      ? this.textStyleReader.readTextStyle(this.editingSource, !!this.shouldInputFreeAll, this.isFocused)
      : this.sourceAsTextDrawableObject.textStyle;
  }

  get textStyleProperties() {
    return {
      color: this.textStyle.color.value,
      fontFamily: this.textStyle.fontFamily,
      fontSize: this.textStyle.displayFontSize + "px",
      textAlign: this.toTextAlignValue(this.textStyle.textAlign),
      verticalAlign: this.toTextVerticalAlignValue(this.textStyle.textAlign), // input, textareaでは効かない
      lineHeight: this.getLineHeightValue(),
    };
  }

  /**
   * line-heightの指定について、IEでは小数点以下も指定通りに表示してくれるが、chromeでは狭くなってしまう
   * 確認したところ、font-size * line-heightで計算して小数点以下を切り捨てた値が行間になっている模様
   * 例: 16 * 1.06 = 16.96　だが行間16pxの表示
   * ※値のみの指定と単位有りの指定とで、子要素に適用されるかどうかの動作が異なるらしいので、
   * 　子要素に異なるline-heightを適用させるコンポーネントには使用できない見込み(末端の要素に適用させる必要あり)
   */
  getLineHeightValue(): string {
    // 単一行指定の時はline-heightを考慮しない模様
    if (!this.textStyle.isMultiLine) {
      // Firefoxは単一行指定の場合でもline-heightを考慮しないと正しく表示できない
      return (BrowserUtility.getBrowserKind() === BrowserKinds.MozillaFirefox)
        ? this.textStyle.lineHeight.toString()
        : this.textStyle.displayFontSize + "px";
    }

    return BrowserUtility.isChromiumBrowser()
      ? DecimalUtility.roundDown(this.textStyle.lineHeight * this.textStyle.displayFontSize, 2) + "px"
      : this.textStyle.lineHeight.toString();
  }

  toTextAlignValue(kind: TextAlignKinds): string {
    if (kind & TextAlignKinds.Left) {
      return "left";
    } else if (kind & TextAlignKinds.Center) {
      return "center";
    } else if (kind & TextAlignKinds.Right) {
      return "right";
    }
    return null;
  }

  toTextVerticalAlignValue(kind: TextAlignKinds): string {
    if (kind & TextAlignKinds.Top) {
      return "top";
    } else if (kind & TextAlignKinds.Middle) {
      return "middle";
    } else if (kind & TextAlignKinds.Bottom) {
      return "bottom";
    }
    return null;
  }
}
